module.exports = __webpack_public_path__ + "static/media/A2_05.6a29eb5f.png";